import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import ResolutionItem from './ResolutionItem';
import BinaryResolutionItem from './BinaryResolutionItem';

const ResolutionList = ({
	resolutions,
	activeYear,
	isUpdateAllowed,
	isAddAllowed,
	isDeleteAllowed,
	isUpdating,
	onUpdateResolution,
	onDeleteResolution,
	onDecryptResolution,
}) => {
	const { t } = useLanguage();

	return (
		<div>
			<div className='mb-4'>
				<h2 className='text-lg font-semibold text-gray-900'>{`${activeYear} ${t('resolutions')}`}</h2>
				<p className='text-sm text-gray-600'>
					{resolutions.length} {resolutions.length !== 1 ? t('resolutions') : t('resolution')} {t('total')}
				</p>
			</div>

			<div className='grid gap-4 md:grid-cols-2 lg:grid-cols-3'>
				{resolutions.map((resolution) =>
					resolution.type === 'binary' ? (
						<BinaryResolutionItem
							key={resolution.id}
							resolution={resolution}
							isUpdateAllowed={isUpdateAllowed(activeYear)}
							isDeleteAllowed={isDeleteAllowed(resolution.year)}
							isUpdating={isUpdating}
							onUpdate={onUpdateResolution}
							onDelete={onDeleteResolution}
							onDecrypt={onDecryptResolution}
						/>
					) : (
						<ResolutionItem
							key={resolution.id}
							resolution={resolution}
							isUpdateAllowed={isUpdateAllowed(activeYear)}
							isAddAllowed={isAddAllowed()}
							isDeleteAllowed={isDeleteAllowed(resolution.year)}
							isUpdating={isUpdating}
							onUpdate={onUpdateResolution}
							onDelete={onDeleteResolution}
							onDecrypt={onDecryptResolution}
						/>
					)
				)}
			</div>
		</div>
	);
};

export default ResolutionList;
